export default "__VITE_ASSET__a932ef48__"